// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3bbac14a","453":"6fa6bb08","732":"50fd6deb"}[chunkId] + ".chunk.js";
};